/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offerdetail_Media_Videos1Inputs */

const id_offerdetail_media_videos1 = /** @type {(inputs: Offerdetail_Media_Videos1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video`)
};

const ms_offerdetail_media_videos1 = /** @type {(inputs: Offerdetail_Media_Videos1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video`)
};

const da_offerdetail_media_videos1 = /** @type {(inputs: Offerdetail_Media_Videos1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Videoer`)
};

const de_offerdetail_media_videos1 = /** @type {(inputs: Offerdetail_Media_Videos1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Videos`)
};

const en_us2_offerdetail_media_videos1 = /** @type {(inputs: Offerdetail_Media_Videos1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Videos`)
};

const es_es2_offerdetail_media_videos1 = /** @type {(inputs: Offerdetail_Media_Videos1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Videos`)
};

const es_mx2_offerdetail_media_videos1 = /** @type {(inputs: Offerdetail_Media_Videos1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Videos`)
};

const fil_offerdetail_media_videos1 = /** @type {(inputs: Offerdetail_Media_Videos1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Video`)
};

const fr_offerdetail_media_videos1 = /** @type {(inputs: Offerdetail_Media_Videos1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vidéos`)
};

const it_offerdetail_media_videos1 = /** @type {(inputs: Offerdetail_Media_Videos1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video`)
};

const hu_offerdetail_media_videos1 = /** @type {(inputs: Offerdetail_Media_Videos1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Videók`)
};

const nl_offerdetail_media_videos1 = /** @type {(inputs: Offerdetail_Media_Videos1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video's`)
};

const no_offerdetail_media_videos1 = /** @type {(inputs: Offerdetail_Media_Videos1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Videoer`)
};

const pl_offerdetail_media_videos1 = /** @type {(inputs: Offerdetail_Media_Videos1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Filmy`)
};

const pt_br2_offerdetail_media_videos1 = /** @type {(inputs: Offerdetail_Media_Videos1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vídeos`)
};

const pt_offerdetail_media_videos1 = /** @type {(inputs: Offerdetail_Media_Videos1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vídeos`)
};

const ro_offerdetail_media_videos1 = /** @type {(inputs: Offerdetail_Media_Videos1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Videoclipuri`)
};

const fi_offerdetail_media_videos1 = /** @type {(inputs: Offerdetail_Media_Videos1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Videot`)
};

const sv_offerdetail_media_videos1 = /** @type {(inputs: Offerdetail_Media_Videos1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Videor`)
};

const vi_offerdetail_media_videos1 = /** @type {(inputs: Offerdetail_Media_Videos1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video`)
};

const tr_offerdetail_media_videos1 = /** @type {(inputs: Offerdetail_Media_Videos1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Videolar`)
};

const cs_offerdetail_media_videos1 = /** @type {(inputs: Offerdetail_Media_Videos1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Videa`)
};

const bg_offerdetail_media_videos1 = /** @type {(inputs: Offerdetail_Media_Videos1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Видеа`)
};

const ru_offerdetail_media_videos1 = /** @type {(inputs: Offerdetail_Media_Videos1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Видео`)
};

const uk_offerdetail_media_videos1 = /** @type {(inputs: Offerdetail_Media_Videos1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Відео`)
};

const ar_offerdetail_media_videos1 = /** @type {(inputs: Offerdetail_Media_Videos1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الفيديو`)
};

const hi_offerdetail_media_videos1 = /** @type {(inputs: Offerdetail_Media_Videos1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वीडियो`)
};

const th_offerdetail_media_videos1 = /** @type {(inputs: Offerdetail_Media_Videos1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`วิดีโอ`)
};

const ja_offerdetail_media_videos1 = /** @type {(inputs: Offerdetail_Media_Videos1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`動画`)
};

const zh_cn2_offerdetail_media_videos1 = /** @type {(inputs: Offerdetail_Media_Videos1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`视频`)
};

const zh_hant1_offerdetail_media_videos1 = /** @type {(inputs: Offerdetail_Media_Videos1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`影片`)
};

const ko_offerdetail_media_videos1 = /** @type {(inputs: Offerdetail_Media_Videos1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`동영상`)
};

/**
* | output |
* | --- |
* | "Videos" |
*
* @param {Offerdetail_Media_Videos1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const offerdetail_media_videos1 = /** @type {((inputs?: Offerdetail_Media_Videos1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offerdetail_Media_Videos1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_offerdetail_media_videos1(inputs)
	if (locale === "ms") return ms_offerdetail_media_videos1(inputs)
	if (locale === "da") return da_offerdetail_media_videos1(inputs)
	if (locale === "de") return de_offerdetail_media_videos1(inputs)
	if (locale === "en-US") return en_us2_offerdetail_media_videos1(inputs)
	if (locale === "es-ES") return es_es2_offerdetail_media_videos1(inputs)
	if (locale === "es-MX") return es_mx2_offerdetail_media_videos1(inputs)
	if (locale === "fil") return fil_offerdetail_media_videos1(inputs)
	if (locale === "fr") return fr_offerdetail_media_videos1(inputs)
	if (locale === "it") return it_offerdetail_media_videos1(inputs)
	if (locale === "hu") return hu_offerdetail_media_videos1(inputs)
	if (locale === "nl") return nl_offerdetail_media_videos1(inputs)
	if (locale === "no") return no_offerdetail_media_videos1(inputs)
	if (locale === "pl") return pl_offerdetail_media_videos1(inputs)
	if (locale === "pt-BR") return pt_br2_offerdetail_media_videos1(inputs)
	if (locale === "pt") return pt_offerdetail_media_videos1(inputs)
	if (locale === "ro") return ro_offerdetail_media_videos1(inputs)
	if (locale === "fi") return fi_offerdetail_media_videos1(inputs)
	if (locale === "sv") return sv_offerdetail_media_videos1(inputs)
	if (locale === "vi") return vi_offerdetail_media_videos1(inputs)
	if (locale === "tr") return tr_offerdetail_media_videos1(inputs)
	if (locale === "cs") return cs_offerdetail_media_videos1(inputs)
	if (locale === "bg") return bg_offerdetail_media_videos1(inputs)
	if (locale === "ru") return ru_offerdetail_media_videos1(inputs)
	if (locale === "uk") return uk_offerdetail_media_videos1(inputs)
	if (locale === "ar") return ar_offerdetail_media_videos1(inputs)
	if (locale === "hi") return hi_offerdetail_media_videos1(inputs)
	if (locale === "th") return th_offerdetail_media_videos1(inputs)
	if (locale === "ja") return ja_offerdetail_media_videos1(inputs)
	if (locale === "zh-CN") return zh_cn2_offerdetail_media_videos1(inputs)
	if (locale === "zh-Hant") return zh_hant1_offerdetail_media_videos1(inputs)
	return ko_offerdetail_media_videos1(inputs)
});
export { offerdetail_media_videos1 as "offerDetail.media.videos" }